import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import type {TApplePayConfig} from 'coreClasses/applepay/types/TApplePayAPI';
import ApplePayDefaultHandler from 'brandComponents/ApplePayButton/handlers/ApplePayDefaultHandler';

/**
 * useApplePayDefault custom hook.
 * @param {boolean} [isActive=false] - indicate whatever this hook is active
 * @param {TApplePayConfig} config - ApplePay configuration
 */
const useApplePayDefault = (isActive: boolean, config: TApplePayConfig) => {
	const {managerRepository} = useGeneralProvider();

	const handlePayment = (productID?: string) => {
		const applePayHandler = new ApplePayDefaultHandler(managerRepository, config);

		return applePayHandler.handlePayment(productID);
	};

	return {
		loaded: isActive,
		loading: false,
		handle: handlePayment
	};
};

export default useApplePayDefault;
